import React, { useEffect, useState } from 'react'
import { Bar, BarValue, SkillName } from './StyledComponents';
import {  Box, Grid, Typography } from '@mui/material';
import { HeadingText} from '../StyledComponents';

function Skills() 
{
  
  let skillSet=[
    {skillName:"HTML",skillValue:95},
    {skillName:"CSS",skillValue:90},
    {skillName:"JavaScript",skillValue:90},
    {skillName:"React",skillValue:90},
    {skillName:"MUI",skillValue:90},
    {skillName:"Angular",skillValue:50},
    {skillName:"Node",skillValue:90},
    {skillName:"Express",skillValue:90},
    {skillName:"MongoDB",skillValue:90},
    {skillName:"Java",skillValue:85},
  ]
  const[countArr,setCountArr]=useState(skillSet.map(()=>0));

  
  useEffect(()=>
  {
    let timers=skillSet.map((obj,index)=>
      {
        return setInterval(()=>
          {
            setCountArr((previousCounts)=>
            {
              let temp=[...previousCounts];
              if(temp[index]<obj.skillValue)
              {
                temp[index]+=1;
              }
              
              return temp;
            });
          },2000/obj.skillValue)
      });
      return () => {
        timers.forEach((timer) => clearInterval(timer));
      };
  },[])
  
  return (
    <>
    <Box id="skill" my={5}>
      <Box sx={{textAlign:"center"}} my={5} data-aos="fade-up" data-aos-duration="2000">
        <HeadingText text="Skills" mb={5} variant='h1' >
          My Skills
        </HeadingText>
        <Typography  variant='h7' sx={{color:"shade.light"}} >
          Mastering the full spectrum of web technologies, I seamlessly integrate front-end and back-end development to create cohesive, high-performing applications that deliver exceptional user experiences and meet diverse business needs
        </Typography>
      </Box>
      <Grid container columns={{ xs: 4, sm: 8, md: 12 }} rowSpacing={{ xs: 6, md: 4 }} columnSpacing={{ xs: 2, md: 4 }}>
          {skillSet.map((obj,index)=>
          {
            return(
            <Grid item xs={2} sm={4} md={6} key={index} data-aos="fade-up" data-aos-duration="2000">
              <SkillName>
                <Typography >{obj.skillName}</Typography>
                <Typography >{countArr[index]}%</Typography>
              </SkillName>
              <Bar>
                <BarValue value={obj.skillValue}/>
              </Bar>
            </Grid>
            )
          })}
      </Grid>
    </Box>
    </>
  )
}

export default Skills